import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

interface Principle {
  title: string;
  text: string;
}

interface Stat {
  value: string;
  label: string;
}

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './about.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./about.scss']
})
export class About {
  // ── Personalise this block ────────────────────────────────────────────────
  // For search-engine trust (E-E-A-T), a real, named author matters. Replace
  // the placeholders below with your real name and a one-line, honest bio.
  readonly founderName = 'The Every Rupee Spent team';
  readonly founderRole = 'Founder & Editor';
  readonly founderBio =
    'Every Rupee Spent is built and maintained by a small, independent team based in India, committed to getting the numbers right. We build the tools we wished existed when planning our own loans, taxes and investments.';
  // ──────────────────────────────────────────────────────────────────────────

  readonly stats: Stat[] = [
    { value: '20+', label: 'Free calculators' },
    { value: '₹0', label: 'To calculate, no login' },
    { value: '4', label: 'Premium services' },
    { value: 'India', label: 'Rules, rates & rupees' }
  ];

  readonly principles: Principle[] = [
    {
      title: 'Accuracy first',
      text: 'Every calculator uses standard, published financial formulas and is backed by automated tests that check the math against worked examples. When rates or tax rules change, we update the tools.'
    },
    {
      title: 'Built for India',
      text: 'PPF, EPF, SSY, NPS, HRA, the old vs new tax regime, quarterly-compounded FDs — the rules, rates and conventions are Indian, not adapted from a US calculator.'
    },
    {
      title: 'Free and private',
      text: 'The calculators are free and need no account. Your numbers are processed in your browser — we do not store the figures you type or sell your data.'
    },
    {
      title: 'Honest about limits',
      text: 'Our tools give estimates, not advice. We tell you plainly what a result can and cannot do, and always point you to a qualified professional for real decisions.'
    }
  ];

  readonly methodology: string[] = [
    'We start from the standard, published formula for each instrument — the EMI reducing-balance formula, compound-interest and annuity formulas, the statutory PPF/EPF/SSY rules, and the income-tax slabs for the relevant financial year.',
    'We write automated tests that check each calculator against worked examples and known reference values, so a change can never silently break the math.',
    'We show the full working where it helps you trust the result — amortization schedules, year-wise breakdowns and charts, not just a single final number.',
    'We review interest rates, tax slabs and scheme parameters when they change (for example at Budget time or when small-savings rates are revised) and update the tools and their "last updated" context.'
  ];
}
